import React from 'react';
import { CheckCircle2, HelpCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingTable() {
  return <section id="pricing" className="py-20 bg-gray-50" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-212">
          <div data-id="element-213">
            <h2 className="text-[#d4af37] font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-214">
              Wholesale Structure
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-215">
              Transparent MOQ & Pricing
            </h3>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-216">
              We support businesses of all sizes. Whether you are just starting
              your hair brand or are an established distributor, we have a tier
              for you.
            </p>

            <div className="space-y-6" data-id="element-217">
              <div className="flex gap-4" data-id="element-218">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#7E3007]/10 flex items-center justify-center text-[#4B280B]" data-id="element-219">
                  <span className="font-bold" data-id="element-220">1</span>
                </div>
                <div data-id="element-221">
                  <h4 className="font-bold text-gray-900 text-lg" data-id="element-222">
                    Sample Order
                  </h4>
                  <p className="text-gray-600" data-id="element-223">
                    No minimum quantity. Test our quality before committing to
                    bulk. Mix textures allowed.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-224">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#7E3007]/10 flex items-center justify-center text-[#4B280B]" data-id="element-225">
                  <span className="font-bold" data-id="element-226">2</span>
                </div>
                <div data-id="element-227">
                  <h4 className="font-bold text-gray-900 text-lg" data-id="element-228">
                    Wholesale Order
                  </h4>
                  <p className="text-gray-600" data-id="element-229">
                    MOQ 3kg (approx 30 bundles). Access standard wholesale deals
                    and free gift.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-230">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#7E3007]/20 flex items-center justify-center text-[#7E3007]" data-id="element-231">
                  <span className="font-bold" data-id="element-232">3</span>
                </div>
                <div data-id="element-233">
                  <h4 className="font-bold text-gray-900 text-lg" data-id="element-234">
                    Distributor / VIP
                  </h4>
                  <p className="text-gray-600" data-id="element-235">
                    Orders over 10kg. Deepest discounts, priority production,
                    and custom packaging support.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-236">
            <div className="bg-[#4B280B] p-6 text-center" data-id="element-237">
              <h3 className="text-white font-bold text-xl" data-id="element-238">
                Wholesale Discount Tiers
              </h3>
              <p className="text-white/80 text-sm mt-1" data-id="element-239">
                Based on order volume per transaction
              </p>
            </div>

            <div className="p-8" data-id="element-240">
              <table className="w-full" data-id="element-241">
                <thead data-id="element-242">
                  <tr className="border-b border-gray-100" data-id="element-243">
                    <th className="text-left py-4 text-gray-500 font-medium text-sm" data-id="element-244">
                      Order Volume
                    </th>
                    <th className="text-right py-4 text-gray-500 font-medium text-sm" data-id="element-245">
                      Discount
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50" data-id="element-246">
                  <tr data-id="element-247">
                    <td className="py-4 font-semibold text-gray-900" data-id="element-248">
                      Under 3kg
                    </td>
                    <td className="py-4 text-right text-[#4B280B] font-bold" data-id="element-249">
                      OFF $15/kg
                    </td>
                  </tr>
                  <tr data-id="element-250">
                    <td className="py-4 font-semibold text-gray-900" data-id="element-251">
                      3kg - 9kg
                    </td>
                    <td className="py-4 text-right text-[#7E3007] font-bold" data-id="element-252">
                      OFF $30/kg
                    </td>
                  </tr>
                  <tr data-id="element-253">
                    <td className="py-4 font-semibold text-gray-900" data-id="element-254">
                      10kg - 49kg
                    </td>
                    <td className="py-4 text-right text-green-600 font-bold" data-id="element-255">
                      VIP Tier 1 (OFF 5-7%)
                    </td>
                  </tr>
                  <tr data-id="element-256">
                    <td className="py-4 font-semibold text-gray-900" data-id="element-257">50kg+</td>
                    <td className="py-4 text-right text-[#d4af37] font-bold" data-id="element-258">
                      Factory Partner (-10%)
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-8 bg-gray-50 p-4 rounded-lg flex gap-3 items-start" data-id="element-259">
                <HelpCircle className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-260" />
                <p className="text-xs text-gray-500" data-id="element-261">
                  *Prices fluctuate based on raw material costs. Contact us for
                  the most up-to-date price list spreadsheet.
                </p>
              </div>

              <Button fullWidth className="mt-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-262">
                Request Price List
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}